
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { fetchReagentById } from "@/services/reagentService";
import ReagentImageSection from "@/components/reagents/ReagentImageSection";
import ReagentInfoSection from "@/components/reagents/ReagentInfoSection";
import OwnerInfoCard from "@/components/reagents/OwnerInfoCard";
import HowItWorksCard from "@/components/reagents/HowItWorksCard";
import ReagentDetailsSkeleton from "@/components/reagents/ReagentDetailsSkeleton";
import ReagentNotFound from "@/components/reagents/ReagentNotFound";

const ReagentDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  
  const { data: reagent, isLoading, error } = useQuery({
    queryKey: ['reagent', id],
    queryFn: () => fetchReagentById(id!),
    enabled: !!id,
  });

  // Scroll to top when page loads (useful after reagent upload redirect)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isLoading) {
    return <ReagentDetailsSkeleton />;
  }

  if (error || !reagent) {
    return <ReagentNotFound />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <div className="mb-4">
          <Link to="/reagents" className="text-reagent-blue hover:underline">
            ← Back to Reagents
          </Link>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <Card className="overflow-hidden">
              <ReagentImageSection reagent={reagent} />
              <ReagentInfoSection reagent={reagent} />
            </Card>
          </div>
          
          <div className="lg:col-span-1">
            <Card className="mb-6">
              <CardContent className="p-0">
                <OwnerInfoCard reagent={reagent} />
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-0">
                <HowItWorksCard />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ReagentDetailsPage;
